module.exports = __webpack_public_path__ + "static/Vapeurs.cc4b065c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Vapeurs.jpg
// module id = 465
// module chunks = 35783957827783